module.exports = __webpack_public_path__ + "static/v1.c-thumb-668d05d21f3741ff37baafcc774076d2.jpg";